import useMask from "@/hooks/useMask"
import { useCallback, useEffect, useMemo, useRef } from "react"

interface IInputProps{
    masks?: string[]
    allowX?: boolean
    className?: string
    name?: string
    placeholder?: string
    value?:string
    type?: string
    onChange: (value: string) => void
    onClick: (event: any) => void
    onFocus?: (event: any) => void
    onBlur?: (event: any) => void
    disabled?: boolean
    minLenght?: number
    maxLenght?: number
    readOnly?: boolean
}

const Input = (props: IInputProps) => {

    const masks = useMemo(() => props.masks ?? [], [props.masks]);
    const { value, maskValue } = useMask(masks);

        const valueRef = useRef<string>('');
        valueRef.current = value ?? '';

        useEffect(() => {
            props.onChange(value ?? '')
        }, [value]);

        useEffect(() => {
            if (!props.value) {
                return
            }
            if (props.value !== valueRef.current) {
                maskValue(props.value);
            }
        }, [props.value]);

        const handleChange = useCallback((event: any) => {
            const val = event.target.value;
            maskValue(val);
        }, []);

        return (
            <input
                value={value ?? ''}
                onChange={handleChange}
                type={props.type}
                onClick={props.onClick}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                className={props.className}
                readOnly={props.readOnly}
                name={props.name}
                placeholder={props.placeholder}
                minLength={props.minLenght}
                maxLength={props.maxLenght}
                disabled={props.disabled}
                data-hj-allow
            />
        );
}

export default Input